import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitpos'
})
export class SplitposPipe implements PipeTransform {

  transform(stringToSplit: string, splitChar: string, splitPart: number): string {
    var retval = ''
    var splitted = stringToSplit.split(splitChar)
    if (splitPart < splitted.length) retval = splitted[splitPart]
    return retval
  }

}
